module.exports = __webpack_public_path__ + "static/media/ta-08.a119ef61.png";